module.exports = __webpack_public_path__ + "80a483ce836bf8fec1ecdddb68654d94.svg";